import { render } from "./EmployeeForm.vue?vue&type=template&id=1c7ede56&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"

import "./EmployeeForm.vue?vue&type=style&index=0&id=1c7ede56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c7ede56"

export default script